import $$ from "cmn-utils";
import leader from "./leader";
import share from "./share";
import { formatData } from "@/utils/formatter";

const baseUrl = "/api/sys/unit/v2/";
export default {
  create: (params) => {
    return $$.post(baseUrl + "create", params);
  },
  delete: (params) => {
    return $$.post(baseUrl + "delete", params);
  },
  get: (params) => {
    return $$.get(baseUrl + "get", params);
  },
  getDetail: (params) => {
    return $$.get(baseUrl + "get-detail", params);
  },
  list: (params) => {
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === "null" || params[key] === "undefined")
        delete params[key];
    });
    return $$.get(baseUrl + "list", params);
  },
  listCategoryUnit: (params) => {
    return $$.get(baseUrl + "list-category-unit", params);
  },
  listMap: (params) => {
    return $$.get(baseUrl + "list-map", params);
  },
  tree: (params) => {
    formatData(params);
    return $$.get(baseUrl + "tree", params);
  },
  treeSelect: (params, type) => {
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === "null" || params[key] === "undefined")
        delete params[key];
    });
    let ret = new Promise((resolve) => {
      $$.get(baseUrl + "tree", params).then((value) => {
        let retValue = value;
        if (retValue) {
          const formatTree = [
            JSON.parse(
              JSON.stringify(retValue)
                .replace(/name/g, "title")
                .replace(/id/g, "value")
                .replace(/childrenList/g, "children")
            ),
          ];

          let formatUnitTree = (tree, disType) => {
            tree &&
              tree.length &&
              tree.forEach((item) => {
                if (disType === "Unit") {
                  item.children = item.children.filter(
                    (f1) => f1.type !== `Unit`
                  );
                  formatUnitTree(item.children, disType);
                } else {
                  item.disabled = disType === item.type;
                  formatUnitTree(item.children, disType);
                }
              });
          };
          retValue = JSON.parse(JSON.stringify(formatTree));
          switch (type) {
            case `Organs`:
              formatUnitTree(retValue, "Organs");
              break;
            case `Unit`:
              formatUnitTree(retValue, "Unit");
              break;
            default:
              break;
          }
        }
        resolve(retValue);
      });
    });
    return ret;
  },
  tree2: (params) => {
    return $$.get(baseUrl + "tree", params);
  },
  update: (params) => {
    return $$.post(baseUrl + "update", params);
  },
  updateAascription: (params) => {
    return $$.post(baseUrl + "update-ascription", params);
  },
  ImportUnitExcelV1: (data, formData) => {
    let url = baseUrl + "import-unit-excel-v1";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
  leader,
  share,
};
